import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import resourcesToBackend from "i18next-resources-to-backend";

// Eager: Default-Sprache (de) + Englisch — sofort verfügbar, keine Ladeverzögerung,
// und prerender-sicher (der Puppeteer-Prerender erzwingt de, s.u.).
import de from "./locales/de.json";
import en from "./locales/en.json";

// Alle übrigen Sprachen (zh/hi/es/fr/ru/ar) werden erst bei Sprachwechsel per
// dynamischem Import nachgeladen → sie liegen NICHT mehr im Initial-Bundle
// (spart ~690 KB / ~45 % Bundle-Größe → deutlich kürzere Parse-/Render-Zeit).

// Detect prerender context (Puppeteer headless) — force German default for AI-crawler indexing
const isPrerender =
  typeof navigator !== "undefined" &&
  /HeadlessChrome|jsdom|Puppeteer/i.test(navigator.userAgent || "");

i18n
  .use(LanguageDetector)
  .use(
    // Vite erzeugt pro Locale-Datei einen eigenen Chunk; nur die aktuell
    // gewählte Sprache wird tatsächlich angefordert.
    resourcesToBackend((lng) => import(`./locales/${lng}.json`)),
  )
  .use(initReactI18next)
  .init({
    // de + en vorab gebündelt; der Rest kommt aus dem Backend (dynamischer Import).
    resources: {
      en: { translation: en },
      de: { translation: de },
    },
    partialBundledLanguages: true,
    fallbackLng: "de",
    lng: isPrerender ? "de" : undefined,
    debug: false,

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },
  });

export default i18n;
